import React from "react";
import ReactDOM from "react-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "../assets/logoMobilecopy.png";
import link from "../assets/link.png";
import pic from "../assets/blue.png";
import Chart from "react-google-charts";
import { useState, useEffect } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import CareTeamCard from "../components/CareTeamCard";
import { BiPlusMedical } from "react-icons/bi";
import CircularProgress from "@mui/material/CircularProgress";
// const patientId = `${AsyncStorage.getItem('dtt_user_id')}`

const CareTeam = ({ navigation }) => {
  const [careTeamMembers, setCareTeamMembers] = useState([]);
  const [RoomLink, setRoomLink] = useState('');
  const [showButton, setshowButton] = useState(false);
  const [handleopen, sethandleopen] = useState(false);
  const [submitting, setsubmitting] = useState(false);

  useEffect(() => {
    const patientId = localStorage.getItem("dtt_PatientId");
    const token = localStorage.getItem("dtt_PatientToken");

    if (!patientId || !token) return;

    setsubmitting(true);

    // Fetch care team members
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/CareTeamMembers/getPatientCareTeamMembers?patientId=${parseInt(patientId)}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setCareTeamMembers(response.data);
        console.log("Care Team Data", response.data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setsubmitting(false);
      });

    // Fetch room link
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientPortal/getPatientRoomNameByPatientId?patientId=${parseInt(patientId)}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setsubmitting(false);
        if (response.data === 'Meeting is not Created against that Patient') {
          console.log("No Room id Found Against this");
        }
        else if (response.data === undefined || response.data === null) {
          console.log("No Patient Found Against this");
        }
        else {
          setRoomLink(response.data);
          console.log("Join meeting room Link", response.data);
          setshowButton(true);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setsubmitting(false);
      });
  }, []); // Empty dependency array - run once on mount


  const handleJoinRoom = () => {
    sethandleopen(true)
    window.open(RoomLink, '_blank');
  };

  const Item = ({ item }) => {
    return (
      <CareTeamCard
        photoUrl={item.photoUrl}
        firstName={`${item.lastName}, ${item.firstName}`}
        memberName={`${item.memberName}`}
        role={`${item.role}`}
        title={`${item.title}`}
        responsiblities={`${item.responsiblities}`}
        providerName={`${item.providerName}`}
      />
    );
  };

  return (<>
  {submitting?(
        <CircularProgress
          style={{
            width: "50px",
            marginTop:'7rem',
            position: "absolute",
            left: "50%",
            marginLeft: "-25px",
            color: "#FCBE13",
          }}
        />
      ):(
        <Container maxWidth="lg" style={{ marginTop: 30, marginBottom: 30 }}>
          {/* Page Header */}
          <Row style={{ marginBottom: 30 }}>
            <Col xs={12}>
              <div style={{
                background: "linear-gradient(135deg, #31A5D7 0%, #2EA4D6 100%)",
                padding: "30px",
                borderRadius: "15px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                color: "white",
                textAlign: "center"
              }}>
                <h2 style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: "32px",
                  marginBottom: "10px"
                }}>
                  Your Care Team
                </h2>
                <p style={{
                  margin: 0,
                  fontSize: "16px",
                  opacity: 0.9
                }}>
                  Meet the healthcare professionals dedicated to your wellbeing
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={8}>
              {careTeamMembers != null && careTeamMembers.length > 0
                ? careTeamMembers.map((row, index) => <Item key={index} item={row} />)
                : (
                  <div style={{
                    padding: "40px",
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "10px",
                    border: "2px dashed #ddd"
                  }}>
                    <p style={{
                      fontSize: "18px",
                      color: "#666",
                      margin: 0
                    }}>
                      No Care Team Members Found
                    </p>
                  </div>
                )}
            </Col>

            {showButton && (
              <Col sm={12} md={4}>
                <div style={{
                  position: "sticky",
                  top: "100px",
                  padding: "20px",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  textAlign: "center"
                }}>
                  <h4 style={{
                    marginBottom: "15px",
                    color: "#2c3e50",
                    fontWeight: 600
                  }}>
                    Virtual Consultation
                  </h4>
                  <Button
                    className="button"
                    type="submit"
                    style={{
                      borderRadius: 10,
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                      backgroundColor: "#FCBE13",
                      border: "none",
                      padding: "12px 30px",
                      fontSize: "16px",
                      width: "100%",
                      boxShadow: "0 4px 8px rgba(252, 190, 19, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 12px rgba(252, 190, 19, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 8px rgba(252, 190, 19, 0.3)";
                    }}
                    onClick={handleJoinRoom}
                  >
                    <BiPlusMedical style={{ marginBottom: "4px", marginRight: '8px' }} />
                    Join Video Call
                  </Button>
                  <p style={{
                    marginTop: "15px",
                    fontSize: "13px",
                    color: "#666"
                  }}>
                    Connect with your care team instantly
                  </p>
                </div>
              </Col>
            )}
          </Row>
  
  
        </Container>
      )}

      {handleopen && (
        <div
          id="iframe_container"
          style={{
            position: 'fixed',
            top: '80px',
            bottom: '0',
            left: '0',
            right: '0',
            backgroundColor: 'rgba(0,0,0,0.9)',
            zIndex: 9999,
            padding: '20px',
          }}
        >
          <Button
            onClick={() => sethandleopen(false)}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              zIndex: 10000,
              backgroundColor: '#e74c3c',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Close Call
          </Button>
          <iframe
            name="ifr"
            title="Video Call"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '10px',
            }}
            src={`${RoomLink}`}
            allow="microphone; camera"
            allowFullScreen
          ></iframe>
        </div>
      )}
 
    </>

  );
};
export default CareTeam;
